import api from '@/lib/api';

export const adminEmailsApi = {
  listNames: async (): Promise<string[]> => {
    const response = await api.get('/emails/templates');
    return response.data;
  },

  // The backend returns a preformatted plain-text block, not JSON.
  getTemplate: async (templateName: string): Promise<string> => {
    const response = await api.get(`/emails/${encodeURIComponent(templateName)}`);
    return response.data;
  },

  deleteTemplate: async (templateName: string): Promise<void> => {
    await api.delete(`/emails/${encodeURIComponent(templateName)}`);
  },
};
